import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import React from 'react';
import {
    Controlled_AutocompleteMultiSelectReferenceTextField,
} from './Controlled_AutocompleteMultiSelectReferenceTextField';
import { useRoleActions } from '../../../../resource/resources/artifacts/role/roleResource';

export const Controlled_RoleTextField= ({ objectIds, projectVersionId, onChange, readOnly, noLabel, propertyValidationInformation }: {
    objectIds: string[] | undefined;
    projectVersionId: string | undefined | null;
    onChange?: (id: string[] | null) => void;
    readOnly: boolean;
    noLabel?: boolean;
    propertyValidationInformation?: PropertyValidationInformation;
}) => {

    const roleActions = useRoleActions()
    const rolesQuery = roleActions.useGetAllResources(projectVersionId);

    return (
        <Controlled_AutocompleteMultiSelectReferenceTextField
            idValues={objectIds}
            readOnly={readOnly}
            onChange={onChange}
            // propertyValidation={propertyValidation}
            // propertyDetails={noLabel ? undefined : propertyDetails}
            propertyValidation={null}
            propertyDetails={undefined}
            query={rolesQuery}
            getOptionLabel={(option) => option.name}
            hideLabel={noLabel}
        />
    );
};